import React from 'react';
import { withRouter } from 'react-router-dom';
import HeaderContent from './HeaderContent';
import { Button } from 'antd';
const WikiContent = (props) => {
  return <div></div>;
};

export default withRouter(WikiContent);
